import React from "react";
import { IconController } from "../../Scripts/ImgController";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
const Wrapper = styled.div`
  .shadow-CK {
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  }
`;
const CreationCard = ({
  gradientColor,
  icon,
  number,
  numberColor,
  desc,
  descColor,
  loaded,
  className,
}) => {
  return (
    <Wrapper className={`${className ? className : "w-1/2 lg:w-1/3"} p-2 md:p-3`}>
      <div
        className="w-full h-full rounded-xl p-4 md:p-6 shadow-CK"
        style={{
          background: `linear-gradient(270deg, #${gradientColor}4d 0.09%, #${gradientColor}0d 99.91%)`,
        }}
      >
        <div className="flex flex-row justify-between gap-2 pb-3 items-center">
          {loaded ? (
            <h4
              className="font-bold text-xl md:text-3xl break-all"
              style={{ color: `#${numberColor}` }}
            >
              {number}
            </h4>
          ) : (
            <div className="w-1/3 h-full opacity-20">
              <Skeleton
                baseColor={"#" + numberColor}
                highlightColor={"#" + descColor}
                height="36px"
              />
            </div>
          )}
          <IconController src={icon} className="w-8 h-8 md:w-10 md:h-10 flex-shrink-0" />
        </div>
        <h5
          className="font-semibold text-xs"
          style={{ color: `#${descColor}` }}
        >
          {desc}
        </h5>
      </div>
    </Wrapper>
  );
};

export default CreationCard;
